<template>
  <div>
    <Loader v-if="!initialized" />
    <div v-else class="main-container">
      <TopBar />
      <Main />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Loader from "@/components/ui/Loader.vue";
import Main from "@/components/ui/Main.vue";
import TopBar from "@/components/ui/TopBar.vue";

export default {
  name: "Home",
  components: { Loader, Main, TopBar },
  computed: {
    ...mapState({
      initialized: state => state.room.initialized,
      highscores: state => state.room.highscores,
      rooms: state => state.room.rooms,
      room: state => state.room.room,
      user: state => state.auth.user
    }),
  }
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 100vh;
  overflow: hidden;
}
</style>
